import React from "react";

const RulesRegulations = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>The Rules, Regulations, Instructions, Manuals & Record</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          For discharging various functions, employees of the Corporation use
          various manuals, circulars and other instructions issued from time to
          time. All the manuals and circulars are available in the Corporation
          in the form of Hard copy.
        </p>

        <p>
          All Rules, regulations and instructions as may be issued by Haryana
          Govt. from time to time.
        </p>

        <p>
          The Company Section follows all the rules and regulations as per
          Companies Act, 2013 (which could be seen at www.mca.gov.in). Further
          the following record of stakeholders of the Corporation has been
          prepared on the regular basis.
        </p>

        <p>
          1. Shareholders Registers
          <br />
          2. Share Transfer Register
          <br />
          3. Share Transmission Register
          <br />
          4. Duplicate Share Register
          <br />
          5. Director&rsquo;s Register
          <br />
          6. Attendance registers of various meetings
          <br />
          7. Minutes book of various meetings as per Companies Act.2013
          <br />
          8. Register of RTI Appeals.
          <br />
          The RTI appeals are heard as per the rules framed under RTI Act, 2005.
        </p>
      </div>
    </div>
  );
};

export default RulesRegulations;
